<template>
  <div class="home-subscribe-form-parent">
    <div class="home-subscribe-form-block">
      <section class="top-border"/>
      <section class="home-subscribe-form-innerblock blog">
        <h1>{{ $t('home-page.subscribe.read-more') }}</h1>

        <hr class="hr-grey">

        <p>Subscribe for our blog latest updates, promotions and more.</p>

        <form @submit.prevent="submitForm" class="subscribe-form">
          <input
            type="email"
            name="email"
            v-model="email"
            required
            placeholder="Enter your email address"
            class="s-input"
            :class="{ 'error': validationError }"
            @focus="clearError"
          >

          <div
            class="s-button-link s-button-link-hover button-primary-dark"
            @click="submitForm"
            :disabled="isSubmitting"
          >
            <span class="s-button-slot">
              {{ isSubmitting ? 'Subscribing...' : 'Subscribe' }}
            </span>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import { usePageContext } from "vike-vue/usePageContext"

export default {
  name: 'BlogSubscribeForm',
  data() {
    return {
      email: '',
      validationError: false,
      isSubmitting: false
    }
  },
  computed: {
    pageContext() {
      return usePageContext()
    }
  },
  methods: {
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    clearError() {
      this.validationError = false;
    },
    async submitForm() {
      if (!this.email || !this.validateEmail(this.email)) {
        this.validationError = true;
        return;
      }

      this.isSubmitting = true;

      try {
        const response = await fetch('https://www.seedr.cc/v2/signup', {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `email=${encodeURIComponent(this.email)}`
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Success:', data);

        this.email = ''; // Clear form after successful submission
        window.Swal.fire({
          title: 'Congratulations!',
          text: 'You have been subscribed to our newsletter.',
          icon: 'success'
        });
      } catch (error) {
        console.error('Error:', error);
        let errorMessage = 'Something went wrong. Please try again later.';

        if (error.message.includes('Failed to fetch')) {
          errorMessage = 'Unable to connect to the server. Please check your internet connection.';
        } else if (error.message.includes('HTTP error!')) {
          errorMessage = 'Server error. Please try again later.';
        }

        window.Swal.fire({
          title: 'Oops!',
          text: errorMessage,
          icon: 'error'
        });
      } finally {
        this.isSubmitting = false;
      }
    }
  }
}
</script>
